import React from 'react'
import { useParams, useHistory } from 'react-router-dom'
import TopNavigation from '../TopNavigation'
import { Container, Row, Col, Button } from 'reactstrap'
import { useTranslation } from 'react-i18next'
import withAppconfig from '../AppContext'
import LottieAnim from './LottieAnim'

function AddCardResult({ appconfig }) {
  const params = useParams()
  const history = useHistory()
  const { t } = useTranslation()
  const isSuccess = params.status === 'success'

  const onComplete = () => {
    history.push(appconfig.pathPrefix + '/profile')
  }

  return (
    <div className='full-page-background'>
      <TopNavigation title={t('add_card')} />
      <Container className='front'>
        <Row className='text-center' style={{ paddingTop: 20, marginBottom: 30 }}>
          <Col className={'mx-auto'} xs={3}>
            <LottieAnim status={params.status} onComplete={isSuccess ? onComplete : undefined} />
            {isSuccess ? t('card_added') : t('card_add_failed')}
          </Col>
        </Row>
        {!isSuccess ? (
          <Row className='text-center'>
            <Col>
              <Button size='sm' color='primary' onClick={() => history.push(appconfig.pathPrefix + '/addcard')}>
                {t('retry')}
              </Button>{' '}
              <Button size='sm' color='link' onClick={() => history.push(appconfig.pathPrefix + '/profile')}>
                {t('back')}
              </Button>
            </Col>
          </Row>
        ) : null}
      </Container>
    </div>
  )
}

export default withAppconfig(AddCardResult)
